import PlatformActions from './PlatformActions'

export default class PINOYPERYAHANActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'LIVE',
      gameCode: 'PINOYPERYAHAN-LIVE-001',
      platform: 'PINOYPERYAHAN',
    }

    this.gameName = 'KaraKrus'

    this.constantTipInfo = {
      tipsItem: 'GT202508200002',
    }
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: txnId, // 6C83hrLqIY5n
      roundId, // 1003-33195
      betType: null,
      currency,
      betTime, // 2025-07-29T02:00:22.000+08:00
      betAmount,
      jackpotBetAmount: 0,
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      refPlatformTxId,
      roundId,
      updateTime,
      betTime,
      txTime,
      turnover,
      betAmount,
      winAmount,
      isJackpotWin,
      gameResult,
    }, txnIdx) => {
      // 同個下注位置的有效投注會總和在其中一筆上
      // 例如：都下注在 HHH 共兩筆，每筆下注各 5，就會加總 10 記在其中一筆 txn 上

      // 對押下注位置的話則是會相減後計算在其中一筆上
      // 例如：同時下注 HHH、TTT 算是對押行為
      // 1. 下注在 HHH 5、下注在TTT 5，則這兩筆注單的有效投注計算則都會是0
      // 2. 下注在 HHH 20、下注在TTT 5，則有效投注計算則都會是15，可能會記錄在 HHH 的注單，TTT的住單記錄的有效投注則會是 0
      let newTurnover = turnover
      if (isJackpotWin && txnList.length > 1) {
        if (txnIdx === 0) {
          newTurnover = Number((txnList.reduce((acc, curr) => acc + curr.turnover, 0)).toFixed(4))
        } else {
          newTurnover = 0
        }
      }

      return {
        ...this.constantTxnData,
        gameName: this.gameName,
        userId,
        platformTxId: txnId, // U2g024kVIlM
        refPlatformTxId, // 6C83hrLqIY5n
        settleType: 'refPlatformTxId',
        updateTime, // 2025-07-29T02:00:28.065+08:00
        roundId, // 1003-33195
        betType: null,
        betTime,
        txTime,
        turnover: newTurnover,
        betAmount,
        winAmount,
        jackpotWinAmount: 0,
        gameInfo: {
          isJackpotWin,
          totalJackpotContribution: Number((betAmount * 0.005).toFixed(3)),
          nextRoundJackpotIn: Number((betAmount * 0.003).toFixed(3)),
          gameResult,
          reserveJackpotIn: Number((betAmount * 0.002).toFixed(3)),
        },
      }
    })

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId,
      roundId,
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }

  getAdjustBetMessage(txnList) {
    const { betAmount: formBetAmount } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      updateTime,
      betAmount,
      adjustAmount,
      hasGrandJackpot,
      jackpotPoolAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: txnId, // 2jLXG4zGazW
      roundId, // 1003-33195
      updateTime,
      betAmount,
      adjustAmount,
      gameInfo: {
        reserveJackpotTotal: Number((formBetAmount * 0.002 * 30.5).toFixed(3)), // 30.5 為隨機數
        jackpotPoolEnd: hasGrandJackpot ? -jackpotPoolAmount : jackpotPoolAmount,
      },
    }))

    const message = {
      action: 'adjustBet',
      txns,
    }

    return JSON.stringify(message)
  }

  getTipMessage(txnList) {
    const { currency } = this.formData

    const txns = txnList.map(({
      userId,
      tipTxnId,
      tip,
      txTime,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `${tipTxnId}`, // 17558529652152505989e5077400ab0e
      tip,
      currency,
      txTime,
      tipInfo: this.constantTipInfo,
      type: 'DEALER_TIPPING',
    }))

    const message = {
      action: 'tip',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelTipMessage(txnList) {
    const txns = txnList.map(({
      userId,
      tipTxnId,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `${tipTxnId}`,
      tipInfo: this.constantTipInfo,
      type: 'DEALER_TIPPING',
    }))

    const message = {
      action: 'cancelTip',
      txns,
    }

    return JSON.stringify(message)
  }
}
